import { lang } from '@umu/ukit-lang';
import { Message } from '@umu/umu-design';
import { useRequest, useDebounceFn } from 'ahooks';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import { useCallback, useState } from 'react';
import {
    ICertificateItemInfo,
    getEnterpriseCertObtainedUserList,
    getHtmlToPicStatus,
    getStudentCertificateInfo,
    migrateHtmlToPic,
} from './api';
import { getDownloadUrl } from '../../@utils';

const downloadFile = (url: string, title: string) => {
    const element = document.createElement('a');
    element.setAttribute('href', url);
    element.setAttribute('download', title);
    element.click();
};

interface IProps {
    courseId: string;
    isTask?: boolean;
    refreshDeps?: any[];
    withPicUrl?: boolean;
}
export const useGetEnterpriseCert = (props: IProps) => {
    const { courseId, refreshDeps,withPicUrl=true } = props;

    const [picLoading, setPicLoading] = useState(true);
    const {
        data: picData,
        run,
        cancel,
    } = useRequest(
        (picId: string) => {
            return getHtmlToPicStatus({ id: picId });
        },
        {
            manual: true,
            pollingInterval: 1000,
            onSuccess: (res) => {
                if (res?.data?.pic_url) {
                    cancel();
                    setPicLoading(false);
                }
            },
        },
    );
    
    // 开启条件：1.数据为空 2.证书状态不为1
    const isOpen = useCallback((certData?: ICertificateItemInfo) => {
        if (!certData || isEmpty(certData)) {
            return false;
        }
        // // 依赖任务，则只在任务页展示，否则只在课程页展示
        if (certData.certificate_base_info.depend_learning_task) {
            return false;
        }
        // 企业证书不启用，则不显示
        if(certData.certificate_base_info.status == 0){
            return false;
        }

        return true;
    }, []);

    const { data: userListData, run: getUserList } = useRequest(
        () =>
            getEnterpriseCertObtainedUserList({
                course_id: courseId,
                page: 1,
                size: 3,
            }),
        {
            manual: true,
        },
    );

    const { loading, data } = useRequest(() => getStudentCertificateInfo({ course_id: courseId }), {
        refreshDeps,
        onBefore: () => {
            cancel();
        },
        onSuccess: async (res) => {
            if (res && res.data && !isEmpty(res.data) && res.data.student_info) {
                const { student_info } = res.data;
                const newParams = {
                    obj_id: courseId,
                    obj_type: '27',
                    student_id: student_info.umu_id,
                };
                if (isOpen(res.data) && withPicUrl) {
                    getUserList();
                    const result = await migrateHtmlToPic(newParams);
                    if (result) {
                        run(result.data.id);
                    }
                } else {
                    setPicLoading(false);
                }
            } else {
                setPicLoading(false);
            }
        },
    });

    const entCertUrl = picData?.data?.pic_url;
    const { run: donwload } = useDebounceFn(
        (imgName: string) => {
            if (entCertUrl) {
                Message.show({
                    message: lang('正在下载，请稍候'),
                    duration: 3000,
                    style: 'z-index:10100',
                });
                const newUrl = getDownloadUrl(entCertUrl, imgName, 'jpg');
                entCertUrl && downloadFile(newUrl, imgName);
            }
        },
        {
            wait: 3000,
            leading: true,
            trailing: false,
        },
    );

    return {
        loading: loading || picLoading,
        isOpen: !loading && isOpen(data?.data),
        certData:data?.data,
        // 是否获得
        isReceived: !!get(data, 'data.student_certificate_info.grant_ts'),
        url: entCertUrl,
        donwload,
        // 是否停用
        isStop: get(data, 'data.certificate_base_info.status') == 2,
        userList: userListData?.data,
    };
};
